import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { Button, IconButton } from "@mui/material";

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const SubContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ToolbarButton = muiStyled(Button)({
  height: 42,
  paddingInline: 18,
  fontWeight: 700,
});

export const ToolbarButtonExport = muiStyled(Button)({
  height: 42,
  paddingInline: 14,
  backgroundColor: "var(--dp-surface)",
  color: "var(--dp-text)",
  border: "1px solid var(--dp-border-strong)",
  "&:hover": {
    backgroundColor: "var(--dp-surface-raised)",
    borderColor: "var(--dp-muted)",
  },
});

export const ToolbarButtonExportContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const ToolbarIconButton = muiStyled(IconButton)({
  width: 42,
  height: 42,
  borderRadius: 12,
  backgroundColor: "var(--dp-surface)",
  color: "var(--dp-muted)",
  border: "1px solid var(--dp-border)",
  "&:hover": {
    backgroundColor: "var(--dp-surface-raised)",
    color: "var(--dp-text)",
  },
});

export const SearchButton = muiStyled(Button)({
  height: 42,
  paddingInline: 16,
  fontWeight: 700,
  backgroundColor: "var(--dp-text)",
  color: "var(--dp-bg)",
  "&:hover": {
    backgroundColor: "var(--dp-text-soft)",
  },
});
